import { floatingSafeAreas, floatingViewportArea } from '@/shared/utils/floatingViewport'

export { floatingViewport as coachViewport } from '@/shared/utils/floatingViewport'

export function coachSafeAreas(element: HTMLElement) {
  return floatingSafeAreas(element, '--coach-safe-')
}

export function coachViewportArea(element: HTMLElement) {
  return floatingViewportArea(element, '--coach-safe-')
}
